export default __webpack_public_path__ + "static/media/MetamaskLogo.4ef605ed.svg";